module.exports = __webpack_public_path__ + "img/qr_code.f4b42cb7.jpg";